import React, { InputHTMLAttributes } from 'react';

interface InputTextBlockProps extends InputHTMLAttributes<HTMLInputElement> {

}

const InputTextBlock = (props: InputTextBlockProps) => {
    const { ...nativeProps } = props;
    return (
        <>
            <input type="text" className='input-block' {...nativeProps} />
        </>
    );
};

export default InputTextBlock;